<template>
    <div class="p-3">
        <h3>RL 4.1 Kompilasi Penyakit/Morbiditas Pasien Rawat Inap</h3>
        <hr />

        <DataTable
            table-id="table-pasien"
            title="Kompilasi Penyakit/Morbiditas Pasien Rawat Inap"
            :filter-configs="filterConfigs"
            :table-options="tableOptions"
            :show-filter="true"
        />

        <div class="d-flex justify-content-end mt-3">
            <table class="table table-bordered w-auto">
                <thead>
                    <tr>
                        <th>Total Keseluruhan</th>
                        <th>Persentase</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>{{ formatNumber(grandTotal) }}</td>
                        <td>{{ persentaseTotal }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import DataTable from "@/components/global/DataTable.vue";

export default {
    components: {
        DataTable,
    },

    data() {
        return {
            grandTotal: 0,
            persentaseTotal: 0,

            filterConfigs: [
                {
                    id: "start_date",
                    label: "Tanggal Awal",
                    field: "start_date",
                    type: "date",
                    colClass: "col-sm-3",
                    component: "",
                },
                {
                    id: "end_date",
                    label: "Tanggal Akhir",
                    field: "end_date",
                    type: "date",
                    colClass: "col-sm-3",
                    component: "",
                },
            ],

            tableOptions: {
                pagination: true,
                paginationMode: "remote",
                paginationSize: 500,
                paginationSizeSelector: [20, 50, 100, 250, 500],

                baseUrl: "/api/rekapitulasi-morbiditas/morbiditas-ranap",

                layout: "fitData",

                ajaxResponse: (url, params, response) => {
                    let result = response;

                    if (
                        result &&
                        result.data &&
                        !Array.isArray(result.data) &&
                        Array.isArray(result.data.data)
                    ) {
                        result = result.data;
                    }

                    if (!result || !Array.isArray(result.data)) {
                        this.grandTotal = 0;
                        this.persentaseTotal = 0;

                        return {
                            data: [],
                            current_page: 1,
                            last_page: 1,
                            per_page: 500,
                            total: 0,
                            grand_total: 0,
                        };
                    }

                    const rows = result.data.map((item) => {
                        const row = {
                            ...item,

                            a_l: parseInt(item.a_l) || 0,
                            a_p: parseInt(item.a_p) || 0,

                            b_l: parseInt(item.b_l) || 0,
                            b_p: parseInt(item.b_p) || 0,

                            c_l: parseInt(item.c_l) || 0,
                            c_p: parseInt(item.c_p) || 0,

                            d_l: parseInt(item.d_l) || 0,
                            d_p: parseInt(item.d_p) || 0,

                            e_l: parseInt(item.e_l) || 0,
                            e_p: parseInt(item.e_p) || 0,

                            f_l: parseInt(item.f_l) || 0,
                            f_p: parseInt(item.f_p) || 0,

                            g_l: parseInt(item.g_l) || 0,
                            g_p: parseInt(item.g_p) || 0,

                            h_l: parseInt(item.h_l) || 0,
                            h_p: parseInt(item.h_p) || 0,

                            i_l: parseInt(item.i_l) || 0,
                            i_p: parseInt(item.i_p) || 0,

                            j_l: parseInt(item.j_l) || 0,
                            j_p: parseInt(item.j_p) || 0,

                            k_l: parseInt(item.k_l) || 0,
                            k_p: parseInt(item.k_p) || 0,

                            l_l: parseInt(item.l_l) || 0,
                            l_p: parseInt(item.l_p) || 0,

                            m_l: parseInt(item.m_l) || 0,
                            m_p: parseInt(item.m_p) || 0,

                            n_l: parseInt(item.n_l) || 0,
                            n_p: parseInt(item.n_p) || 0,

                            o_l: parseInt(item.o_l) || 0,
                            o_p: parseInt(item.o_p) || 0,

                            p_l: parseInt(item.p_l) || 0,
                            p_p: parseInt(item.p_p) || 0,

                            q_l: parseInt(item.q_l) || 0,
                            q_p: parseInt(item.q_p) || 0,

                            r_l: parseInt(item.r_l) || 0,
                            r_p: parseInt(item.r_p) || 0,

                            s_l: parseInt(item.s_l) || 0,
                            s_p: parseInt(item.s_p) || 0,

                            t_l: parseInt(item.t_l) || 0,
                            t_p: parseInt(item.t_p) || 0,

                            u_l: parseInt(item.u_l) || 0,
                            u_p: parseInt(item.u_p) || 0,

                            v_l: parseInt(item.v_l) || 0,
                            v_p: parseInt(item.v_p) || 0,

                            w_l: parseInt(item.w_l) || 0,
                            w_p: parseInt(item.w_p) || 0,

                            x_l: parseInt(item.x_l) || 0,
                            x_p: parseInt(item.x_p) || 0,

                            y_l: parseInt(item.y_l) || 0,
                            y_p: parseInt(item.y_p) || 0,

                            total_l: parseInt(item.total_l) || 0,

                            total_p: parseInt(item.total_p) || 0,

                            total_all: parseInt(item.total_all) || 0,

                            hidup_l: parseInt(item.hidup_l) || 0,

                            hidup_p: parseInt(item.hidup_p) || 0,

                            hidup_total: parseInt(item.hidup_total) || 0,

                            mati_l: parseInt(item.mati_l) || 0,

                            mati_p: parseInt(item.mati_p) || 0,

                            mati_total: parseInt(item.mati_total) || 0,

                            persentase: parseFloat(item.persentase) || 0,
                        };

                        return row;
                    });

                    let grandTotal = parseInt(result.grand_total) || 0;

                    if (grandTotal <= 0) {
                        grandTotal = rows.reduce((total, item) => {
                            return total + (parseInt(item.total_all) || 0);
                        }, 0);
                    }

                    rows.forEach((item) => {
                        item.persentase =
                            grandTotal > 0
                                ? parseFloat(
                                      (
                                          (item.total_all / grandTotal) *
                                          100
                                      ).toFixed(2)
                                  )
                                : 0;
                    });

                    const totalPersentase = rows.reduce((total, item) => {
                        return total + (parseFloat(item.persentase) || 0);
                    }, 0);

                    this.grandTotal = grandTotal;

                    this.persentaseTotal =
                        grandTotal > 0
                            ? parseFloat(totalPersentase.toFixed(2))
                            : 0;

                    if (
                        this.persentaseTotal > 99.9 &&
                        this.persentaseTotal < 100.1
                    ) {
                        this.persentaseTotal = 100;
                    }

                    result.data = rows;
                    result.grand_total = grandTotal;

                    return result;
                },

                columns: [
                    {
                        title: "Kode ICD-10",
                        field: "kode_icd",
                        width: 120,
                        frozen: true,
                    },

                    {
                        title: "Diagnosis Penyakit",
                        field: "diagnosa",
                        width: 350,
                        frozen: true,
                    },

                    {
                        title: "Jumlah Pasien Keluar Hidup dan Mati Menurut Kelompok Umur & Jenis Kelamin",

                        columns: [
                            {
                                title: "< 1 Jam",

                                columns: [
                                    {
                                        title: "L",
                                        field: "a_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "a_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "1-23 Jam",

                                columns: [
                                    {
                                        title: "L",
                                        field: "b_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "b_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "1-7 Hari",

                                columns: [
                                    {
                                        title: "L",
                                        field: "c_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "c_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "8-28 Hari",

                                columns: [
                                    {
                                        title: "L",
                                        field: "d_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "d_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "29 Hari - <3 Bln",

                                columns: [
                                    {
                                        title: "L",
                                        field: "e_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "e_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "3 - <6 Bln",

                                columns: [
                                    {
                                        title: "L",
                                        field: "f_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "f_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "6-11 Bln",

                                columns: [
                                    {
                                        title: "L",
                                        field: "g_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "g_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "1-4 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "h_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "h_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "5-9 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "i_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "i_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "10-14 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "j_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "j_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "15-19 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "k_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "k_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "20-24 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "l_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "l_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "25-29 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "m_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "m_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "30-34 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "n_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "n_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "35-39 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "o_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "o_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "40-44 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "p_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "p_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "45-49 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "q_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "q_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "50-54 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "r_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "r_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "55-59 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "s_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "s_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "60-64 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "t_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "t_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "65-69 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "u_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "u_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "70-74 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "v_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "v_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "75-79 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "w_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "w_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "80-84 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "x_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "x_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "≥85 Th",

                                columns: [
                                    {
                                        title: "L",
                                        field: "y_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "y_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },

                            {
                                title: "Total",
                                field: "total_all",
                                hozAlign: "center",
                                width: 70,
                            },
                        ],
                    },

                    {
                        title: "Jumlah Pasien Keluar Hidup dan Mati Menurut Jenis Kelamin",

                        columns: [
                            {
                                title: "L",
                                field: "total_l",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "P",
                                field: "total_p",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "Total",
                                field: "total_all",
                                hozAlign: "center",
                                width: 70,
                            },
                        ],
                    },

                    {
                        title: "Jumlah Pasien Keluar Hidup",

                        columns: [
                            {
                                title: "L",
                                field: "hidup_l",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "P",
                                field: "hidup_p",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "Total",
                                field: "hidup_total",
                                hozAlign: "center",
                                width: 70,
                            },
                        ],
                    },

                    {
                        title: "Jumlah Pasien Keluar Mati",

                        columns: [
                            {
                                title: "L",
                                field: "mati_l",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "P",
                                field: "mati_p",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "Total",
                                field: "mati_total",
                                hozAlign: "center",
                                width: 70,
                            },
                        ],
                    },
                ],

                height: "600px",
            },
        };
    },

    methods: {
        formatNumber(value) {
            return new Intl.NumberFormat("id-ID").format(parseInt(value) || 0);
        },
    },
};
</script>
